export type GovernorMaturityLevel =
  | "L1_FOUNDATION"
  | "L2_REGISTERED"
  | "L3_RUNTIME_CONNECTED"
  | "L4_EVIDENCE_PRODUCING"
  | "L5_SELF_HEALING"
  | "L6_EXECUTIVE_SUPERVISED";

export interface GovernorMaturityRecord {
  id: string;
  domain: string;
  level: GovernorMaturityLevel;
  runtimeEvidence: boolean;
  selfHealing: boolean;
  executiveSupervision: boolean;
  nextAction: string;
}

export const GOVERNOR_MATURITY_MATRIX: GovernorMaturityRecord[] = [
  {
    id: "executive",
    domain: "Executive Governor",
    level: "L6_EXECUTIVE_SUPERVISED",
    runtimeEvidence: true,
    selfHealing: false,
    executiveSupervision: true,
    nextAction: "Use Executive Governor to supervise all registered domains."
  },
  {
    id: "tree",
    domain: "Tree Governor",
    level: "L4_EVIDENCE_PRODUCING",
    runtimeEvidence: true,
    selfHealing: false,
    executiveSupervision: false,
    nextAction: "Place under Executive Governor and activate verified tree checks."
  },
  {
    id: "calls",
    domain: "Calls Governor",
    level: "L4_EVIDENCE_PRODUCING",
    runtimeEvidence: true,
    selfHealing: false,
    executiveSupervision: false,
    nextAction: "Place under Executive Governor and use live evidence to diagnose unanswered calls."
  },
  {
    id: "membership",
    domain: "Membership Governor",
    level: "L3_RUNTIME_CONNECTED",
    runtimeEvidence: false,
    selfHealing: false,
    executiveSupervision: false,
    nextAction: "Connect membership policies to runtime subscription/seat evidence."
  },
  {
    id: "kinsspace",
    domain: "KinsSpace Governor",
    level: "L1_FOUNDATION",
    runtimeEvidence: false,
    selfHealing: false,
    executiveSupervision: false,
    nextAction: "Register and activate storage/media/runtime evidence paths."
  },
  {
    id: "business",
    domain: "Business Governor",
    level: "L3_RUNTIME_CONNECTED",
    runtimeEvidence: false,
    selfHealing: false,
    executiveSupervision: false,
    nextAction: "Connect billing, pricing, founder count, seats, and Stripe evidence."
  }
];
